import { KeepAlive } from 'vue'

const routes = [
  {
    path: '/camp',
    redirect: { name: 'CampDetail' },
    meta: { layout: 'default' },
    children: [
      // 캠핑장 상세
      {
        path: 'detail/:instId',
        name: 'CampDetail',
        meta: { layout: 'default', menu: 'camp'},
        component: () => import('@/pages/camp/CampDetailView.vue'),
      },
      {
        path: 'rsvt',
        name: 'CampRsvt',
        meta: { layout: 'default', menu: 'camp' },
        component: () => import('@/pages/camp/CampRsvtView.vue'),
      },
      {
        path: 'done',
        name: 'CampDone',
        meta: { layout: 'default', menu: 'camp' },
        component: () => import('@/pages/camp/CampDoneView.vue'),
      },
    ]
  }
]

export default routes


